import type { TEventSchemas, TEventSchemasShape } from '../types/taxonomy.types';

export const defineEventSchemas = <S extends TEventSchemas & TEventSchemasShape<S>>(events: S) => events;
